import { render, staticRenderFns } from "./Otherdoc.vue?vue&type=template&id=5819fd2e&"
import script from "./Otherdoc.vue?vue&type=script&lang=js&"
export * from "./Otherdoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports